import React, { createContext, useContext } from "react";
import { useNotify } from "../hooks/useNotify";

const WSContext = createContext();

export const WSProvider = ({ children }) => {
  const ws = useNotify();

  return (
    <WSContext.Provider value={ws}>
      {children}
    </WSContext.Provider>
  );
};

export const useWS = () => useContext(WSContext);